// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bd-2";
export var aiChatCartContainerExit = "_bd-4";
export var aiChatContainerLarge = "_bd-0";
export var aiChatContainerSmall = "_bd-1";
export var aiChatIcon = "_bd-6";
export var slideInFromRight = "_bd-3";
export var slideOutToRight = "_bd-5";